import { render, staticRenderFns } from "./logoff.vue?vue&type=template&id=87b88f44&"
import script from "./logoff.vue?vue&type=script&lang=js&"
export * from "./logoff.vue?vue&type=script&lang=js&"
import style0 from "./logoff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbItem: require('/app/components/breadcrumb/BreadcrumbItem.vue').default,Breadcrumb: require('/app/components/breadcrumb/Breadcrumb.vue').default,Button: require('/app/components/button/Button.vue').default,Form: require('/app/components/form/Form.vue').default,Article: require('/app/components/article/Article.vue').default,Sidebar: require('/app/components/Sidebar.vue').default,PageWrap: require('/app/components/PageWrap.vue').default})
